import api from "../config/api";

export const fetchAllSubscriber = async () => {
  const res = await api.get("/subscription/");
  return res.data.data;
};


export const fetchSubscriberById = (id) => {
  const res = api.get(`/subscription/${id}`);
};

export const createSubscriber = async (postData) => {
  const res = await api.post(`/subscription/`, postData);
  return res.data;
};

export const updateSubscriber = async (id, postData) => {
  const res = await api.put(`/subscription/?id=${id}`, postData);
  return res.data;
};

export const deleteSubscriber = async (id) => {
  const res = await api.delete(`/subscription/?id=${id}`);
  return res.data;
};
